import { JSX } from 'react';
import { C02AccordionViewMoreProps } from './C02AccordionViewMore.types';
import { TextAccordion } from '@ahc-digital/component-library';
import { CreateC02AccordionViewMoreModel } from './C02AccordionViewMore.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C02AccordionViewMoreProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <TextAccordion
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...CreateC02AccordionViewMoreModel(props)}
    />
  );
};

export default checkDatasourceForRendering<C02AccordionViewMoreProps>(Default);
